module.exports = __webpack_public_path__ + "img/wxzfsu.78223d12.jpg";